class SwiperItemsIconText extends HTMLElement {
    constructor() {
        super();
        this.swiper = null;
        this.swiperContainer = this.querySelector('.swiper');
    }

    connectedCallback() {
        this.initSwiper();
    }

    initSwiper() {
        const pagination = this.querySelector('.swiper-pagination');
        this.swiper = new Swiper(this.swiperContainer, {
            slidesPerView: 4,
            spaceBetween: 28,
            pagination: {
                el: pagination || null,
                clickable: true,
            },
            breakpoints: {
                320: {
                    spaceBetween: 25,
                    slidesPerView: 1,
                },
                1001: {
                    spaceBetween: 25,
                    slidesPerView: 2,
                },
                1100: {
                    spaceBetween: 28,
                    slidesPerView: 4,
                }
            }
        });
    }


    disconnectedCallback() {
    }
}

customElements.define('swiper-items-icon-text', SwiperItemsIconText);
